import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  ImageInput,
  ImageField,
} from 'react-admin';

export const CategoryCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" label="Name" />
      <TextInput source="slug" label="Slug" />

      <ImageInput source="icon_image" label="Icon image" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>

      <NumberInput source="sort_order" label="Sort order" defaultValue={0} />
      <BooleanInput source="is_active" label="Is active" defaultValue={true} />
    </SimpleForm>
  </Create>
);